import React, { useEffect, useState } from 'react';
import { prefix } from '../../../js/constants';
import css from './ErrorPresenter.module.scss';

const ErrorPresenter = ({ text, tooltipText, tooltipTextDesktop }: { text: string; tooltipText?: string; tooltipTextDesktop?: string }) => {
    const [isTooltipVisible, setIsTooltipVisible] = useState<boolean>(false);

    const closeError = () => {
        setIsTooltipVisible(false);
    };

    const toggleError = (e: React.MouseEvent) => {
        e.stopPropagation();
        setIsTooltipVisible(!isTooltipVisible);
    };

    useEffect(() => {
        document.body.addEventListener('click', closeError);

        return function cleanup() {
            document.body.removeEventListener('click', closeError);
        };
    }, []);

    return (
        <div className={css[prefix]}>
            {!isTooltipVisible ? null : <div className={css[prefix + '__overlay']}></div>}
            <span className={css[prefix + '__text']}>{text}</span>
            <span className={css[prefix + '__question']} onClick={(e) => toggleError(e)}>
                ?
            </span>
            <div className={css[prefix + '__tooltip'] + (isTooltipVisible ? ' ' + css[prefix + '__tooltip--opened'] : '')}>
                <div className={prefix + '__mobile'}>{tooltipText}</div>
                <div className={prefix + '__desktop'}>{tooltipTextDesktop}</div>
            </div>
        </div>
    );
};

export default ErrorPresenter;
